export default "__VITE_ASSET__Bpahmf0c__"